export const BACK_LABEL = 'Homepage';